module.exports = __webpack_public_path__ + "static/media/dazzshop2.0a37abe7.png";